export type StepperItemView = 'idle' | 'error' | 'success';

export type StepperSize = 's' | 'm' | 'l';
